import { motion } from "framer-motion";
import {
  Area,
  AreaChart,
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from "recharts";
import AnimatedCounter from "./AnimatedCounter";

const trendData = [
  { day: "Mon", score: 72, trend: 58 },
  { day: "Tue", score: 74, trend: 62 },
  { day: "Wed", score: 78, trend: 65 },
  { day: "Thu", score: 80, trend: 69 },
  { day: "Fri", score: 83, trend: 72 },
  { day: "Sat", score: 84, trend: 74 },
  { day: "Sun", score: 85, trend: 78 }
];

export default function HeroDashboardPreview() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7 }}
      className="rounded-3xl border border-white/60 bg-white/70 p-5 shadow-2xl backdrop-blur-xl"
    >
      <div className="mb-4 grid grid-cols-3 gap-3">
        <div className="rounded-2xl bg-indigo-50 p-3">
          <p className="text-xs text-gray-500">Health Score</p>
          <p className="text-xl font-bold text-indigo-600">
            <AnimatedCounter value={85} />
          </p>
        </div>
        <div className="rounded-2xl bg-emerald-50 p-3">
          <p className="text-xs text-gray-500">Improvement</p>
          <p className="text-xl font-bold text-emerald-600">
            <AnimatedCounter value={40} prefix="+" suffix="%" />
          </p>
        </div>
        <div className="rounded-2xl bg-sky-50 p-3">
          <p className="text-xs text-gray-500">Clarity</p>
          <p className="text-xl font-bold text-sky-600">
            <AnimatedCounter value={60} prefix="+" suffix="%" />
          </p>
        </div>
      </div>

      <div className="mb-3 h-40">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={trendData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey="day" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="score"
              stroke="#4f46e5"
              strokeWidth={3}
              dot={false}
              isAnimationActive
              animationDuration={1200}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="h-24">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={trendData}>
            <defs>
              <linearGradient id="heroTrend" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#14b8a6" stopOpacity={0.45} />
                <stop offset="95%" stopColor="#14b8a6" stopOpacity={0.05} />
              </linearGradient>
            </defs>
            <XAxis hide dataKey="day" />
            <YAxis hide />
            <Tooltip />
            <Area
              type="monotone"
              dataKey="trend"
              stroke="#0d9488"
              fill="url(#heroTrend)"
              isAnimationActive
              animationDuration={1300}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </motion.div>
  );
}
